(function(){
    angular
        .module('app')
        .directive('ngCondiciones', condiciones);

        condiciones.$inject = ['$timeout'];
        function condiciones($timeout){
            return {
            //restrict:'A',
            //replace: true,
            templateUrl:'/backend/altcrm/filtrostype/condiciones',
            //transclude: true,
            scope: { fields : "=", workflow:"=" },
            require: 'ngModel',
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {
                	scope.condiciones = ngModel.$viewValue;
                 

               
                    
                	scope.addCondicion = function(){
                		scope.condiciones.push({"campo":"","operador":"","valor":""});
                	}
                	scope.borrarCond = function(index){
			      		scope.condiciones.splice(index,1);
			      	}
			      	scope.loadCampo = function(condicion){
			      		condicion.valor="";
			      		for(var cont=0;cont<scope.fields.length;cont++){
			      			if(scope.fields[cont].name==condicion.campo){
			      				condicion.field = scope.fields[cont];
			      				if(condicion.field.value != '')
			          				condicion.field.value = JSON.parse(condicion.field.value);
			      			}
			      		}
                        console.log(condicion);
			      		$timeout(function(){
			      			$('.datepicker').datepicker({ format: 'yyyy-mm-dd'});
			      		})
			      	}

                    

                    //var value = $attrs.value;
                    //var $element = $(element);
                   
                });
            }
          }
      }
})();